'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ItemFacetsMock = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _delay = require('./delay');

var _delay2 = _interopRequireDefault(_delay);

var _mockData = require('./mockData');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemFacetsMock = exports.ItemFacetsMock = {
    fetchItemFacets: function fetchItemFacets(itemIds) {
        return new _promise2.default(function (resolve) {
            setTimeout(function () {
                var itemFacets = itemIds.map(function (x) {
                    return (0, _mockData.getTestItemFacets)(x);
                });
                resolve({
                    data: {
                        data: itemFacets
                    }
                });
            }, _delay2.default);
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/mock/itemFacets.js
// module id = V37k
// module chunks = 57